<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <thead>
                            <tr>
                                <th style="width: 150px;">Catégorie</th> 
                                <th style="width: 150px;">Référence</th>
                                <th>Désignation</th>
                                <th style="width: 120px;">Qté</th>
                                <th class="text-right" style="width: 180px;">Prix de revient HT</th>
                                 <th class="text-center" style="width: 130px;">
                                    Tx {{ margin_type == 2 ? 'marque' : 'marge' }}
                                </th>
                                <th class="text-right" style="width: 180px;">Prix de vente HT</th>
                                <th class="text-right" style="width: 180px;">Total vente HT</th>
                                <th class="text-right"  style="width: 120px;"></th>
                            </tr>
                        </thead>
                        <tbody v-if="!loading">
                            <tr v-for="(serviceList, index) in serviceLists" is="service-list-form"
                                v-bind:key="serviceList.uniq"
                                :ref="serviceList.uniq"
                                :service-list="serviceList"
                                :index="index"
                                :margin-type="margin_type"
                                :suggestionsRoute="suggestionsRoute"
                                :types="JSON.parse(serviceListTypes)"
                                :purchase-types="JSON.parse(purchaseTypes)"
                                :hidden-lines-enabled="hiddenLinesEnabled"
                                v-on:service-list-deleted="deleteRow($event)"
                            >
                            </tr>
                        </tbody>
                         <tbody v-if="loading">
                            <tr>
                                <td colspan="100%" class="text-center">
                                    <i class="far fa-circle-notch fa-spin"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <input type="hidden" :name="'serviceLists[id]'" id="service_list_id" :value="id">
                <button type="button" class="ix-btn link" @click="addRow(null)"><i class="far fa-plus"></i> Nouveau prix</button>
            </div>
        </div>
         <div class="row">
            <div class="col-sm-12 text-right">
                <button type="submit" class="ix-btn green">Enregistrer</button>
            </div>
        </div>
        
    </div>
    
</template>

<script>
import ServiceListForm from './ServiceListForm.vue'

export default {
    name: 'ServiceListTableForm',
    props: ['suggestionsRoute', 'serviceListId', 'serviceListTypes', 'purchaseTypes', 'lines', 'marginType', 'hiddenLinesEnabled'],
    components: {
        ServiceListForm,
    },
    data(){
        return {
            serviceLists: [],
            id : this.serviceListId,
            loading: true,

            margin_type: this.marginType,
            margin_workforce: 0,
            margin_purchases: 0,
            margin_stocks: 0,
            margin_equipments: 0,
        }
    },
    methods: {
        addRow(serviceList){
            var data = {
                id: null,
                uniq: Math.random().toString(36).substr(2, 9),
                type: '',
                type_secondary: 1,
                reference: '',
                designation: '',
                unit: '',
                quantity: 1,
                amount: 0,
                total: 0,
                margin: 0,
                selling: 0,
                total_selling: 0,
                is_hidden_from_client: false,
            }

            if(serviceList != null){
                data.id = serviceList.id;
                data.type = serviceList.type == null ? '' : serviceList.type
                data.type_secondary = serviceList.type_secondary == null ? '' : serviceList.type_secondary
                data.reference = serviceList.reference
                data.unit = serviceList.unit
                data.amount = serviceList.amount
                data.margin = serviceList.margin
                data.designation = serviceList.designation
                data.description = serviceList.description
                data.quantity = serviceList.quantity
                data.selling = serviceList.selling
                data.total_selling = serviceList.total_selling
                data.article_id = serviceList.article_id
                data.is_hidden_from_client = serviceList.is_hidden_from_client == 1
            }

            this.serviceLists.push(data);
        },
        deleteRow(params){
            this.serviceLists.splice(params.index, 1);
        }
    },
    mounted() {
        this.loading = false;
        var jsonData = JSON.parse(this.lines);

        if(Array.isArray(jsonData) && jsonData.length > 0){
            jsonData.forEach(element => {
                this.addRow(element);
            });
        }
    }
}
</script>